import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { PropostaComercialService } from '../../../../services/proposta-comercial.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';

@Component({
  selector: 'app-editar-proposta-comercial',
  templateUrl: './editar-proposta-comercial.component.html',
  styleUrl: './editar-proposta-comercial.component.scss'
})
export class EditarPropostaComercialComponent implements OnInit {
  breadCrumbItems: Array<{}> = [];

  propostraForm!: FormGroup;
  isLoading: boolean = false;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private propostaComercialService: PropostaComercialService,
    private toastService: ToastService) {}

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Projeto" },
      { label: "Proposta comercial", active: true },
    ];

    this.consultarPropostaComercial();

    this.iniciarForm();

  }

  iniciarForm(): void {
    this. propostraForm = this.fb.group({
      descricao: ['', Validators.required],
      configuracao: [''],
      observacao: ['']
    })
  }

  consultarPropostaComercial(): void {
    let id = this.route.snapshot.paramMap.get('id')!;
    this.propostaComercialService.consultarPropostaComercial(id).subscribe({
      next: (response) => {
        
        this.propostraForm.patchValue({
          descricao: response.descricao,
          configuracao: response.configuracao,
          observacao: response.observacao
        })
      }
    })
  }

  onSubmit(): void {

    let id = this.route.snapshot.paramMap.get('id')!;

    if (this.propostraForm.invalid) {
      this.propostraForm.markAllAsTouched();

      return;
    }
    this.isLoading = true;

    let formValue = this.propostraForm.value;

    this.propostaComercialService
      .atualizarPropostaComercial(id, formValue.descricao, formValue.observacao, formValue.configuracao).subscribe({
      next: (Response) => {

        this.toastService.show("Proposta comercial atualizada com sucesso", {
          classname: "bg-success text-light",
        });
      }
    })

    this.isLoading = false;
  }

  voltar() {
    this.location.back();
  }
}
